import React from 'react';
import { Trash2, Edit2 } from 'lucide-react';

interface Product {
  id: string;
  name: string;
  category: string;
  image: string;
  sku: string;
  price: string;
}

interface ProductCardProps {
  product: Product;
  onRemove: () => void;
  onEdit: (product: Product) => void;
  isExport?: boolean;
}

export const ProductCard: React.FC<ProductCardProps> = ({
  product,
  onRemove,
  onEdit,
  isExport = false
}) => (
  <div className={`group relative bg-card rounded-lg border shadow-sm transition-all duration-200 w-full ${
    isExport ? 'border-border' : 'border-border hover:border-primary hover:shadow-md'
  }`}>
    <div className="p-1 sm:p-2">
      <div className="aspect-square bg-muted rounded overflow-hidden mb-1">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <h4 className="font-bold text-[8px] sm:text-[10px] text-foreground mb-0.5 line-clamp-2 min-h-[2.4em] leading-tight">
        {product.name}
      </h4>
      <p className="text-[7px] text-muted-foreground font-mono mb-1">{product.sku}</p>
      {!isExport && (
        <div className="flex items-center justify-between mt-1 pt-1 border-t border-border">
          <span className="text-[9px] font-bold text-primary">{product.price || '$0.00'}</span>
          <div className="flex gap-0.5">
            <button
              onClick={(e) => { e.stopPropagation(); onEdit(product); }}
              className="p-1 hover:bg-secondary rounded text-muted-foreground hover:text-primary transition-colors"
            >
              <Edit2 size={10} />
            </button>
            <button
              onClick={(e) => { e.stopPropagation(); onRemove(); }}
              className="p-1 hover:bg-destructive/10 rounded text-muted-foreground hover:text-destructive transition-colors"
            >
              <Trash2 size={10} />
            </button>
          </div>
        </div>
      )}
    </div>
  </div>
);
